import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AdminApproval.module.css";
import useAuthGuard from "../../../hooks/useAuthGuard";
import { inviteStaffApi } from "../../../api/api";

const AdminInvite = () => {
  useAuthGuard();
  const [role, setRole] = useState("");
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "staff",
    location: "",
  });
  const [msg, setMsg] = useState({ type: "", text: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const r = localStorage.getItem("adminRole");
    setRole(r || "");
  }, []);

  // Admins can invite staff and stringers; only superadmins can invite admins
  const isSuperadmin = role === "superadmin";

  if (role && role !== "superadmin" && role !== "admin") {
    return (
      <div className={styles.full}>
        <div className={styles.card}>
          <h2 className={styles.title}>Access Denied</h2>
          <p className={styles.subtle}>
            You must be an Admin or Super Admin to invite staff.
          </p>
          <button className={styles.btnGhost} onClick={() => navigate(-1)}>
            ← Back
          </button>
        </div>
      </div>
    );
  }

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });

    const { firstName, lastName, email, role, location } = form;
    if (!firstName || !lastName || !email || !role) {
      setMsg({ type: "error", text: "All fields are required." });
      return;
    }

    if (role === "stringer" && !location) {
      setMsg({ type: "error", text: "Location is required for stringers." });
      return;
    }

    try {
      const token = localStorage.getItem("adminToken");
      await inviteStaffApi({ firstName, lastName, email, role, location: role === "stringer" ? location : null, token });
      setMsg({ type: "success", text: "Invitation sent successfully." });
      setForm({ firstName: "", lastName: "", email: "", role: "staff", location: "" });
    } catch (err) {
      const apiMsg =
        err?.response?.data?.error || "Something went wrong. Please try again.";
      setMsg({ type: "error", text: apiMsg });
    }
  };

  return (
    <div className={styles.full}>
      <header className={styles.header}>
        <h1 className={styles.pageHeading}>Invite your Staff</h1>
      </header>

      <main className={styles.main}>
        <form className={styles.card} onSubmit={onSubmit}>
          {msg.text && (
            <div
              className={`${styles.banner} ${
                msg.type === "error" ? styles.bannerError : styles.bannerSuccess
              }`}
            >
              {msg.text}
            </div>
          )}

          <div className={styles.grid}>
            <div className={styles.formRow}>
              <label>First Name</label>
              <input
                name="firstName"
                value={form.firstName}
                onChange={onChange}
                placeholder="First Name"
                required
              />
            </div>

            <div className={styles.formRow}>
              <label>Last Name</label>
              <input
                name="lastName"
                value={form.lastName}
                onChange={onChange}
                placeholder="Last Name"
                required
              />
            </div>

            <div className={`${styles.formRow} ${styles.span2}`}>
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
                placeholder="email@example.com"
                required
              />
            </div>

            <div className={styles.formRow}>
              <label>Role</label>
              <select
                name="role"
                value={form.role}
                onChange={onChange}
                required
              >
                <option value="staff">Staff</option>
                {isSuperadmin && <option value="admin">Admin</option>}
                {isSuperadmin && <option value="superadmin">Super Admin</option>}
                <option value="stringer">Stringer</option>
              </select>
            </div>

            {form.role === "stringer" && (
              <div className={styles.formRow}>
                <label>Location *</label>
                <select
                  name="location"
                  value={form.location}
                  onChange={onChange}
                  required
                >
                  <option value="">Select Location</option>
                  <option value="Jumeirah Store">Jumeirah Store</option>
                  <option value="Marina Store">Marina Store</option>
                  <option value="Dubai Hills Store">Dubai Hills Store</option>
                </select>
              </div>
            )}
          </div>

          <div className={styles.actions}>
            <button type="submit" className={styles.btnPrimary}>
              Send Invite
            </button>
            <button
              type="button"
              className={styles.btnGhost}
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};

export default AdminInvite;
